import React, { BaseSyntheticEvent } from 'react';
import { ObjectSchema } from 'yup';
import cx from 'classnames';

import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export type FormProps = Omit<JSX.IntrinsicElements['form'], 'onSubmit'> & {
  defaultValues?: Record<string, any>;
  onSubmit(
    data: Record<string, any>,
    event?: BaseSyntheticEvent | undefined,
  ): void;
  validationSchema?: ObjectSchema<any>;
};

const Form: React.FC<FormProps> = ({
  children,
  className,
  onSubmit,
  validationSchema,
  defaultValues,
  ...rest
}: FormProps) => {
  const classNames = cx(className);
  const methods = useForm({
    defaultValues,
    resolver: validationSchema && yupResolver(validationSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form className={classNames} {...rest} onSubmit={handleSubmit(onSubmit)}>
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
